<template>
    <v-container fluid class="pa-6 campagne" v-if="campaign">
        <v-row>
            <v-col cols="12" v-if="campaign && campaign.sousType == 'campVMSout' && campaign.status == 'DRAFT'">
                <v-alert class="mb-0" :icon="'$warning_s'" border="left" color="warning" text>
                    <b style="font-size:16px;">{{ $t("VMSrulesText") }}</b>
                </v-alert>
            </v-col>
            <v-col cols="12" v-if="campaign && campaign.type == 'CAMP_OUT_P' && campaign.status == 'WAITING_VALIDATION'">
                <v-alert class="mb-0" :icon="'$warning_s'" border="left" color="warning" text>
                    <div class="d-flex align-center">
                        <b style="font-size:16px;">{{ $t("ContactVarWereCheckedActionRequired") }}</b>
                        <v-spacer></v-spacer>
                        <v-btn small color="warning" @click="actionForContactVar = true" depressed>{{ $t('actionRequired') }}</v-btn>
                    </div>

                </v-alert>
            </v-col>
            <v-col cols="12" v-if="campaign && campaign.sousType == 'campSMSconversational' && campaign.status == 'DRAFT'">
                <v-alert class="mb-0" :icon="'$warning_s'" border="left" color="warning" text>
                    <b style="font-size:16px;">{{ $t("SMSConversationnelRulesText") }}</b>
                </v-alert>
            </v-col>
            <v-col cols="12" v-if="$func.hasRight('retroplanning/configure')">
                <CampaignConfigurationComponent :campaign="campaign" @edit="getForm(editUrl)" />
            </v-col>

            <v-col cols="4" v-if="campaign.config && campaign.config.canal === 'TEL' && campaign.config.prestataire_type === 'CALL' && !campaign.diabolo_campaign.value">
                <v-card rounded="lg" class="mb-6">
                    <v-card-text class="text-center">
                        <v-alert class="mb-0" border="left" color="info" text>
                            {{ $t('noDiaboloCampaignSelected') }}
                            <v-select class="mt-6" hide-details dense solo flat :items="diaboloCampaigns" v-model="diaboloCampaignSelected" return-object></v-select>
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="4" v-else>
                <v-row class="" v-if='campaign.config && campaign.config.canal && (["TEL"]).includes(campaign.config.canal)'>
                    <v-col cols="6" v-if="$func.hasRight('retroplanning/get_objective')">
                        <rdvObjective :data="statCampCall" :key="'camp_call_'+statsCallKey" @editCallStats="getForm(objectiveUrl)"/>
                    </v-col>
                    <v-col cols="6">
                        <treatmentStats :data="statTreatment" :key="'camp_treatment_'+statsCallKey"/>
                    </v-col>
                    <v-col cols="6" v-if="campaign.config && campaign.config.prestataire_type === 'VENDORS'">
                        <campDonutComponent :title="'statsRdvVendor'" :data="statRdvVendor" :key="'camp_rdvVendor_'+statsCallKey"/>
                    </v-col>
                    <v-col cols="6">
                        <campDonutComponent :title="'statsFailMotif'" :data="statFailMotive" :key="'camp_fail_'+statsCallKey"/>
                    </v-col>
                </v-row>

                <NumberStatComponent :colNumber="6" :campaignPage='true' :values="stat" @openStats="openStats"  v-if='campaign.config && campaign.config.canal && !(["TEL"]).includes(campaign.config.canal)'/>
                <NumberStatComponent :colNumber="6" :campaignPage='true' :values="stat" @openStats="openStats"  v-if='campaign.type && campaign.type =="CAMP_IN"'/>

                <campaignStat v-if='campaign.config && campaign.config.canal && (["EMAIL", "SMS", "MMS", "VMS", "RCS"]).includes(campaign.config.canal) && campaign.sousType !== "campSMSconversational"' :campaign="campaign" @openStats="openStats" class="mt-6"/>
                <!-- <campaignStat v-if='campaign.config && campaign.config.canal && (["EMAIL", "SMS", "MMS", "VMS", "RCS"]).includes(campaign.config.canal) && campaign.sousType !== "campSMSconversational" && campaign.campaign_id' :campaign="campaign" @openStats="openStats" class="mt-6"/> -->

                <campaignLinkStat v-if='campaign.config && campaign.config.canal && (["EMAIL", "SMS", "MMS", "VMS", "RCS"]).includes(campaign.config.canal)' class="mt-6"/>               
                <!-- <campaignLinkStat v-if='campaign.config && campaign.config.canal && (["EMAIL", "SMS", "MMS", "VMS", "RCS"]).includes(campaign.config.canal) && campaign.campaign_id' class="mt-6"/>                -->

                <campaignHeralStat v-if='campaign.config && campaign.config.canal && campaign.config.canal === "EMAIL"' :campaign="campaign" class="mt-6"/>
                <!-- <campaignHeralStat v-if='campaign.config && campaign.config.canal && campaign.config.canal === "EMAIL" && campaign.campaign_id' :campaign="campaign" class="mt-6"/> -->

                <TunnelConversionComponent  :type="campaign.sousType" v-if="campaign.sousType === 'campSMSconversational'" :stats="statsTunnel" class="mt-6" />
            </v-col>

            <v-col cols="8">
                <CampaignTemplate v-if="campaign.id" :campaign="campaign" @hasContactVar="hasContactVarFct" :key="'template_'+key"/>

                <OperationContactListComponent :key="'contactList_' + key" :operationId="$route.params.operation_id" v-if="campaign.type && campaign.type != 'CAMP_IN' && $route.params.operation_id" :sousType="campaign.sousType" :limitRetroId="$route.params.id" class="my-4 mt-6" @refreshContactList="refreshContactList" :loadData="true" />

                <CampaignContactListComponent :key="'contactList_' + key" v-else-if="campaign.type && campaign.type != 'CAMP_IN'" :sousType="campaign.sousType" :limitRetroId="$route.params.id" class="my-4 mt-6" @refreshContactList="refreshContactList" :loadData="true" />

                <CampaignBudgetCard v-if="$func.hasRight('retroplanning/displayprice') && (!packId || packId != 1) && campaign.sousType !== 'campSMSconversational'" class="mt-6"/>
            </v-col>
        </v-row>

        <dialogStatsContactComponent v-if="openDialogStats" @closeStatsContactDialog="openDialogStats = false" :openDialogStats="openDialogStats" :prefilter="prefilter" :id="this.$route.params.id" :idType="'retroplanning_id'" />

        <FormDialogComponent v-if="form" ref="componentForm" :type="'edit'" :form="form" :action="'SET_DATA'" />

        <dialogProgramRpComponent v-if="campaign.id" :openProgramRpDialog="openProgramRpDialog" :hasContactVar="hasContactVar" :retroplanning="campaign" @refresh="refresh" @close="openProgramRpDialog = false" :key="'programRpDialog_'+(campaign.entity_id && campaign.entity_id.id ? campaign.entity_id.id : 'empty')"/>
        <v-dialog width="800" hide-overlay persistent v-model="actionForContactVar" v-if="campaign && campaign.stats_var_contacts">
            <v-card>
                <v-toolbar tile flat dark class="bg-gradient">
                    <v-toolbar-title>{{$t('actionrequired')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn depressed text class="square" @click="actionForContactVar = false">
                        <v-icon small> $close </v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <h5 class="mt-5">{{ $t('warningSomeContactVariablesAreEmpty') }}</h5>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        <b style="font-size:14px;">{{$t('usedVariables')}}</b>
                                    </th>
                                    <th class="text-center">
                                        <b style="font-size:14px;">{{ $t('nbMessageWithEmptyVar') }}</b>
                                    </th>
                                </tr>
                            </thead>
                        <tbody>
                            <tr
                            v-for="(nb, index) in campaign.stats_var_contacts.countersVarEmpty"
                            v-show="nb > 0"
                            :key="index"
                            >
                            <td class="py-2">
                                {{ $t(index) }}
                                <div>{{ "\{{"+index+"}\}" }}</div>
                            </td>
                            <td class="text-center">
                                {{  nb  }}
                            </td>
                            </tr>
                        </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions class="d-flex justify-space-around">
                    <v-btn depressed class="mx-2 mb-2 btnprogram h-100" color="mediumgrey" @click="cancelProgramming">{{ $t('cancelProgram') }}</v-btn>
                    <v-btn depressed class="mx-2 mb-2 btnprogram h-100" color="mediumgrey" @click="programSpecificContactVar(false)">{{ $t('sendevenifemptyvar') }} ({{ campaign.stats_var_contacts.contactTotal }})</v-btn>
                    <v-btn depressed v-ripple color="pink" v-if="campaign.stats_var_contacts.contactFull > 0" class="white--text mx-2 mb-2 btnprogram" @click="programSpecificContactVar(true)">{{$t("sendonlytofullcontact")}} ({{ campaign.stats_var_contacts.contactFull }})</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <dialogProgramRpComponent v-if="campaign.id" :openProgramRpDialog="openProgramRpDialog" :retroplanning="campaign" @refresh="refresh" @close="openProgramRpDialog = false" :key="'programRpDial_'+(campaign.entity_id && campaign.entity_id.id ? campaign.entity_id.id : 'empty')"/>
    </v-container>
</template>

<script>
import CampaignConfigurationComponent from '@/modules/campagnes/views/CampaignConfigurationComponent'
import campaignStat from '@/components/dashboardComponent/campaignStat'
import campaignHeralStat from '@/components/dashboardComponent/campaignHeralStat'
import FormDialogComponent from "@/components/dialogs/FormDialogComponent";
import NumberStatComponent from '@/components/dashboardComponent/NumberStatComponent'
import refreshData from '@/mixins/mixins';
import getForm from '@/mixins/mixins'
import GenericDataService from '@/services/GenericDataService'
import CampaignTemplate from '../CampaignTemplate.vue';
import dateManipulation from '@/mixins/dateManipulation'
import dialogStatsContactComponent from '@/components/dialogs/dialogStatsContactComponent'
import OperationContactListComponent from '@/modules/operations/operationsComponents/contactListComponent'
import CampaignContactListComponent from '@/modules/campagnes/campagnesComponents/contactListComponent'
import campaignLinkStat from '@/components/dashboardComponent/campaignLinkStat'
import CampaignBudgetCard from '../CampaignBudgetCard.vue';
import dialogProgramRpComponent from '@/components/dialogs/dialogProgramRpComponent.vue';
import rdvObjective from '@/modules/operations/operationsComponents/rdvObjective.vue';
import treatmentStats from '@/modules/operations/operationsComponents/treatmentStats.vue';
import campDonutComponent from '@/modules/operations/operationsComponents/campDonutComponent.vue';
import TunnelConversionComponent from '@/modules/missions/missionsComponents/acquisitionComponents/tunnelConversionComponent.vue';

export default {
    name:"CampaignDashboard",
    components: {
        FormDialogComponent,
        NumberStatComponent,
        CampaignConfigurationComponent,
        dialogStatsContactComponent,
        campaignStat,
        campaignHeralStat,
        campaignLinkStat,
        OperationContactListComponent,
        CampaignContactListComponent,
        CampaignTemplate,
        CampaignBudgetCard,
        dialogProgramRpComponent,
        rdvObjective,
        treatmentStats,
        campDonutComponent,
        TunnelConversionComponent
    },
    mixins:[refreshData, dateManipulation, getForm],
    data() {
        return {
            stat: {
                title: "fewNumbersTitle",
                data: []
            },
            statCampCall: {},
            statTreatment: {},
            statRdvVendor: {},
            statFailMotive: {},
            template:{},
            form: null,
            apiUrl: "/retroplanning/get?id=" + this.$route.params.id,
            mutation: "campaign/setCampaignData",
            editUrl: "/operation/getFormRealRetroplanning?id=" + this.$route.params.id,
            objectiveUrl : "/retroplanning/"+this.$route.params.id+"/getForm?formName=rdv_objective",
            openDialogStats:false,
            prefilter: false,
            key:0,
            statsCallKey:0,
            statsCampIn: {},
            entrypoint: {},
            diaboloCampaigns: [],
            diaboloCampaignSelected: null,
            statsTunnel: {},
            hasContactVar : false,
             actionForContactVar : false
        }
    },
    destroyed() {
        this.$store.commit("campaign/removeSingleCampaignData");
    },
    mounted() {
        this.refreshData();
    },
    watch: {
        campaign(newVal){
            if(newVal && newVal.type == 'CAMP_CALL') {
                if(newVal.sousType == 'campCALL') {
                    GenericDataService.getData('/retroplanning/getCampCallStats?retroplanning_id=' + this.$route.params.id ).then((response) => {
                        this.statCampCall = response.data.data.statsRdv;
                        this.statTreatment = response.data.data.statsTreatment;
                        this.statRdvVendor = response.data.data.statsRdvVendor;
                        this.statFailMotive = response.data.data.statsMotifFail;
                        this.statsCallKey++;
                    });
                }

                if(newVal.sousType == 'campSMSconversational') {
                    GenericDataService.getData('/retroplanning/getTunnelStats?retroplanning_id=' + this.$route.params.id).then((response) => {
                        this.statsTunnel = response.data.data;
                    });
                }
            }
            
            GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getStats').then((response) => {
                this.stat.data = response.data.data;
            });

            if(this.campaign.config && this.campaign.config.prestataire_type && this.campaign.config.prestataire_type === "CALL") {
                GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getDiaboloCampaigns').then((response) => {
                    this.diaboloCampaigns = response.data.data;
                });
            }

            if(this.campaign.template_id && this.campaign.template_id.id){
                GenericDataService.getData('/template/get?id='+this.campaign.template_id.id).then((response) => {
                    if(response.data.data){
                        this.template = response.data.data
                    }
                })
            }

            if(newVal.actions && newVal.actions.get) {
                newVal.actions.get = JSON.parse(JSON.stringify(newVal.actions.get).replaceAll('{{id}}', this.campaign.id));
                newVal.actions.get.forEach((element, index, object) => {
                    if(element.menus && element.menus[0]){
                        element.menus[0].forEach(elementMenu => {
                            if(elementMenu.check && !newVal.config[elementMenu.check]){
                                elementMenu.disabled = true
                            }
                        });
                    }

                    if(element.name && element.name === "OperationDetail" && !newVal.operation_id) {
                        object.splice(index, 1);
                    }
                });
                this.$store.dispatch("base/SET_HEADER_ACTIONS", newVal.actions.get);
            }

            if(this.campaign.spam_stats && this.campaign.spam_stats.testId) {
                GenericDataService.getData('/retroplanning/' + this.$route.params.id + '/getSpamTestReport?testId=' + this.campaign.spam_stats.testId).then((response) => {
                    this.campaign.spam_stats = response.data.data;
                });
            }

            // this.key++;
        },
        diaboloCampaignSelected(newVal) {
            GenericDataService.postData('/retroplanning/' + this.$route.params.id + '/setDiaboloCampaign', newVal).then((response) => {
                this.refreshData();
            });
        }
    },
    computed: {
        packId(){
            if(this.$store.state.auth.currentUser.accountParameters.packId)
                return this.$store.state.auth.currentUser.accountParameters.packId
            else 
                return false
        },
        campaign(){
            return this.$store.state.campaign.campaign
        },
        openProgramRpDialog: {
            get: function(){
                return this.$store.state.campaign.programRpDialog;
            },
            set: function(val){
                this.$store.dispatch("campaign/SET_PROGRAM_RP_DIALOG", false);
            }
        },
        openSpamTestDialog: {
            get: function(){
                return this.$store.state.campaign.sendSpamTestDialog;
            },
            set: function(val){
                this.$store.dispatch("campaign/SET_SPAMTEST_DIALOG", false);
            }
        },
    },
    methods: {
        cancelProgramming(){
            GenericDataService.getData('/retroplanning/'+this.campaign.id+'/cancelProgramming').then((response)=> {
                this.actionForContactVar = false
                this.refreshData();
            })
        },  
        programSpecificContactVar(full){
            let url = '/retroplanning/'+this.campaign.id+'/programWithSpecificConfig'
            if(full)
                url += '?onlyFull=true'
             GenericDataService.getData(url).then((response)=> {
                this.actionForContactVar = false
                this.refreshData();
            })
        },  
        hasContactVarFct($evt){
            this.hasContactVar = $evt
        },
        refreshContactList(){
            this.refreshData();
        },
        openStats(item){
            this.prefilter = item.prefilter ? item.prefilter : item.label;
            this.openDialogStats = true;
        },
        refresh(){
            this.$store.dispatch("campaign/SET_PROGRAM_RP_DIALOG", false);
            this.$store.dispatch("campaign/SET_SPAMTEST_DIALOG", false);
            this.refreshData();
        }
    }
}
</script>

<style lang="scss">
.btnprogram {
    width:30% !important;
    height: auto !important;
    height: calc(100% - 1px) !important;
}
.btnprogram .v-btn__content {
    margin-top:5px;
    margin-bottom:5px;
    white-space: pre-wrap !important;
    width: 100%;
}
    .campagne {
        
        .todo-title {
            display:flex;
            h3 {
                line-height: 18px;
            }
            p {
                margin-bottom:0;
                font-weight: bold;
                text-decoration: underline;
                color: var(--v-primary-base) !important;
            }
        }
        .v-card__title {
            display:flex;
            justify-content: space-between;
            align-items:flex-start;
            .cardTitle {
                display:flex;
                justify-content:center;
                align-items:center;
                .title {
                    margin-left:10px;
                    p {
                        margin-bottom:0;
                        font-weight:bold;
                        line-height: 12px;
                    }
                    h3 {
                        margin-top:5px;
                        line-height: 20px;
                    }
                }
            }
            .numberTitle {
                display:flex;
                align-items: flex-end;
                justify-content: flex-start;
                font-weight:bold;
                line-height: normal;
                .big {
                    font-size: 2.5em;
                    line-height:40px;
                }
            }
        }
    }
</style>
